module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_7005.23f38f63.png";